export * from "./contexts/AuthContext";
export * from "./constants";
export * from "./firebase";

export const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PASSWORD_REGEX_PATTERN =
  /^(?=.*[A-Z])(?=.*[@#._])(?=.*[0-9])(?!.*[\s])(?!.*[^A-Za-z0-9@#._]).{8,}$/;
